import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  makeStyles,
  TableRow,
  TableBody,
  TableHead,
  TablePagination,
  Grid,
} from "@material-ui/core";
import {
  Toast,
  ConfirmationModal,
  AddLaboratory,
  EditLaboratory,
  SimpleToolbar,
  Loader,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { laboratoryServices, userServices, doctorServices } from "../services";
import { AuthContext } from "../context";
import { useDrawer } from "../hooks";
import {
  EditIconButton,
  EnableDisableIconButton,
  DeleteIconButton,
} from "../components/icon-buttons";
import handleDownloadExcel from "../helpers/download-excel";
export default function LaboratoriesScreen(props) {
  const classes = useStyles();
  const [laboratories, setLaboratories] = useState([]);
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [laboratoryToEdit, setLaboratoryToEdit] = useState(null);
  const [openEditLaboratoryModal, setOpenEditLaboratoryModal] = useState(false);
  const [openAddLaboratoryModal, setOpenAddLaboratoryModal] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [userId, setUserId] = useState(null);
  const [reload, setReload] = useState(false);
  const [specialtiesList, setSpecialtiesList] = useState([]);
  const { isOpen, setIsOpen } = useDrawer();
  const tableHeader = useRef(["Nombre", "Usuario", "Correo", "Estado"]);
  const tableBody = useRef([]);

  useEffect(() => {
    const tableData = laboratories.map((laboratory) => {
      return {
        Nombre: laboratory.name || "",
        Usuario: laboratory.user.username || "",
        Correo: laboratory.user.email || "",
        Estado: laboratory.user.status ? "Activo" : "Inactivo" || "",
      };
    });
    tableBody.current = tableData;
  }, [laboratories]);

  useEffect(() => {
    getLaboratories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, authState, reload, signOut]);

  useEffect(() => {
    async function init() {
      try {
        const { status, response, specialties } =
          await doctorServices.getSpecialties();
        if (status === 200) {
          setSpecialtiesList(response.specialties);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        console.log(e);
      }
    }
    init();
  }, [signOut]);

  const getLaboratories = async (text = "") => {
    try {
      setLoading(true);
      const { status, response } =
        await laboratoryServices.getLaboratoriesFilter({
          page,
          limit,
          text,
          token: authState.token,
        });
      setLoading(false);
      if (status === 200) {
        setLaboratories(response.laboratories);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const updateStatus = async (laboratory) => {
    try {
      setLoading(true);
      const { status } = await userServices.updateUserStatus({
        status: !laboratory.user.status,
        token: authState.token,
        _id: laboratory.user._id,
      });
      setLoading(false);
      if (status === 200) {
        setReload(true);
        setToast(true);
        setToastMessage("Laboratorio actualizado con exito");
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const deleteLaboratory = async () => {
    try {
      setLoading(true);
      const { status, response } = await userServices.deleteUser({
        _id: userId,
        token: authState.token,
      });
      setLoading(false);
      if (status === 200) {
        setReload(true);
        setToast(true);
        setToastMessage(response.message);
      } else if (status === 401) {
        signOut();
      }
      if (response.error) {
        setToast(true);
        setToastMessage(response.error.message);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const handleClose = (value) => {
    setOpenEditLaboratoryModal(value);
    setLaboratoryToEdit(null);
  };

  const handleToast = (message, active) => {
    setToastMessage(message);
    setToast(active);
  };

  const confirmationModal = (_id) => {
    setOpenAlert(true);
    setUserId(_id);
  };

  const optionsToolbar = [
    {
      label: "Exportar excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Laboratorios",
          tableBody: tableBody.current,
          tableHeader: tableHeader.current,
        });
      },
    },
    {
      label: "Agregar",
      action: (e) => {
        setOpenAddLaboratoryModal(true);
      },
    },
  ];

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.container} style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            <ConfirmationModal
              open={openAlert}
              setOpenAlert={setOpenAlert}
              setConfirmAction={() => deleteLaboratory()}
            />
            <Toast
              message={toastMessage}
              open={toast}
              close={() => {
                setToast(false);
              }}
            />
            {openEditLaboratoryModal && (
              <EditLaboratory
                data={laboratoryToEdit}
                open={openEditLaboratoryModal}
                specialtiesList={specialtiesList}
                reload={() => setReload(true)}
                close={() => handleClose(false)}
                toast={(message, active) => handleToast(message, active)}
              />
            )}
            {openAddLaboratoryModal && (
              <AddLaboratory
                specialtiesList={specialtiesList}
                toast={(message, active) => {
                  handleToast(message, active);
                }}
                open={openAddLaboratoryModal}
                close={() => setOpenAddLaboratoryModal(false)}
                // departaments={props.departaments}
                reload={() => setReload(true)}
              />
            )}
            <Container maxWidth={false}>
              <SimpleToolbar
                onFilter={(text) => getLaboratories(text)}
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                options={optionsToolbar}
              />
              <BaseTable tableId="tableLab">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Nombre</StyledTableCell>
                    <StyledTableCell>Usuario</StyledTableCell>
                    <StyledTableCell>Correo</StyledTableCell>
                    <StyledTableCell>Estado</StyledTableCell>
                    <StyledTableCell>Opciones</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {laboratories.map((laboratory, index) => (
                    <StyledTableRow hover key={laboratory._id}>
                      <StyledTableCell>{laboratory.name}</StyledTableCell>
                      <StyledTableCell>
                        {laboratory.user.username}
                      </StyledTableCell>
                      <StyledTableCell>{laboratory.user.email}</StyledTableCell>
                      <StyledTableCell
                        style={{
                          color: laboratory.user.status ? "#22D3C5" : "#FF619A",
                          fontWeight: "bold",
                        }}
                      >
                        {laboratory.user.status ? "Activo" : "Inactivo"}
                      </StyledTableCell>
                      <StyledTableCell>
                        <EditIconButton
                          tooltipTitle="Editar laboratorio"
                          onClick={() => {
                            setOpenEditLaboratoryModal(true);
                            setLaboratoryToEdit(laboratory);
                          }}
                        />
                        <EnableDisableIconButton
                          status={laboratory.user.status}
                          onClick={() => updateStatus(laboratory)}
                          tooltipTitleEnable="Activar laboratorio"
                          tooltipTitleDisable="Desactivar laboratorio"
                        />
                        <DeleteIconButton
                          tooltipTitle="Borrar Laboratorio"
                          onClick={() => confirmationModal(laboratory.user._id)}
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => {
                  setLimit(parseInt(e.target.value));
                }}
                onChangePage={(e, page) => {
                  setPage(page + 1);
                }}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  pagination: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      bottom: 0,
    },
  },
}));
